import { Skeleton, Stack } from "@mui/material";
import React from "react";
import { CreateProjectLayout } from "..";

const CreateProjectSkeleton = (): React.ReactNode => {
  return (
    <CreateProjectLayout>
      <Stack sx={{ flexGrow: 1, width: "100%" }}>
        <Skeleton variant="text" sx={{ typography: "overline", width: 220 }} />
        <Skeleton
          variant="text"
          sx={{ typography: "h4", width: "40vw", maxWidth: 960 }}
        />
        <Skeleton
          variant="text"
          sx={{ typography: "body2", width: "60vw", maxWidth: 960 }}
        />
        <Skeleton
          variant="rectangular"
          sx={{
            width: "100%",
            height: "50%",
            mt: 6,
            borderRadius: 2
          }}
        />
      </Stack>
    </CreateProjectLayout>
  );
};

export default CreateProjectSkeleton;
